// extracted by mini-css-extract-plugin
export var ariane = "ariane-module--ariane--57e98";
export var link = "ariane-module--link--6fd71";
export var separator = "ariane-module--separator--3444f";